<template>
  <div id="invitation" class="c-forgot c-page" v-if="ready">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline">
          <strong>Begynd</strong> abonnement?
        </h1>
        {{ couponDescription }}
      </div>

      <div class="l-tablet-column--6">
        <div v-if="errorMessage" class="c-error">
          <p
            :class="{ 'c-error__text': !formValid, 'c-input-valid__text': formValid }"
          >{{ errorMessage }}</p>
          <router-link
            v-if="suggestCreditcard"
            :to="{ name: 'creditcard', query: { redirect: 'invitation', invitation: coupon } }"
          >Prøv med et andet kort.</router-link>
        </div>

        <form class="c-form general-form">
          <input
            v-model="input.coupon"
            class="c-form__element"
            type="text"
            name="coupon"
            placeholder="Rabatkode"
          />

          <label v-if="coupon" class="c-form__submit" @click.prevent="startSubscription()">
            <SpinnerButton
              ref="request"
              class="c-form__submit"
              cta="Indløs rabat og begynd abonnement"
              action="Indløser rabat og begynder abonnement"
            />

            <input type="submit" value="Login" />
          </label>

          <label v-if="!coupon" class="c-form__submit" @click.prevent="getInfo()">
            <SpinnerButton
              ref="getinfo"
              class="c-form__submit"
              cta="Hent rabat"
              action="Henter rabat"
            />

            <input type="submit" value="Login" />
          </label>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
console.log("LOADED");

import CouponResponse from "@/components/CouponResponse.js";

import SpinnerButton from "@/components/SpinnerButton.vue";

export default {
  name: "Invitation",
  components: {
    SpinnerButton
  },
  mixins: [CouponResponse],
  data() {
    return {
      coupon: this.$route.params.coupon || this.$route.query.invitation || null,
      user: this.$route.meta.user,
      ready: false,
      errorMessage: "",
      formValid: false,
      couponDescription: "",
      suggestCreditcard: false,
      input: {
        coupon: this.$route.params.coupon || this.$route.query.invitation
      }
    };
  },
  mounted() {
    // DO we have a user ?
    if (!this.user) {
      console.log("no user - goto register");
      this.$router.push(
        {
          name: "register",
          query: { redirect: "invitation", invitation: this.coupon }
        },
        () => {
          return;
        }
      );
    }
    console.log("customer");
    console.log(this.user);
    console.log(this.user.customer_id);
    if (!this.user.customer_id) {
      this.$userService.registerCustomer().then(subscription => {
        console.log("no customer - goto creditcard");
        this.$userService.refreshLocalUser().then(() => {
          this.$router.push(
            {
              name: "creditcard",
              query: { redirect: "invitation", invitation: this.coupon }
            },
            () => {
              return;
            }
          );
        });
      });
    } else {
      this.$userService.getCustomer().then(subscription => {


        this.customer = subscription;
        // Do we have a credit card?

        //TODO: is the card invalid?
        console.log('customer')
        console.log(this.customer)
        let card = null;
        this.$userService
          .getPaymentMethod(this.customer.customer)
          .then((card) => {
            card = card;
            console.log('card')
            console.log(card);
            if (!card) {

              this.$router.push(
                {
                  name: "creditcard",
                  query: { redirect: "invitation", invitation: this.coupon }
                },
                () => {
                  return;
                }
              );
            }

            if (card) {
              if (
                this.customer.customer.subscriptions.total_count > 0 &&
                this.customer.customer.subscriptions.data[0] &&
                (this.customer.customer.subscriptions.data[0].status === "active" ||
                  this.customer.customer.subscriptions.data[0].status === "trialing")
              ) {
                // active user
                console.log("go to coupon");
                this.$router.push(
                  {
                    name: "coupon",
                    params: { coupon: this.coupon }
                  },
                  () => {
                    return;
                  }
                );
              } else if (this.coupon) {
                console.log("has coupon");
                this.$userService
                  .getCoupon(this.coupon)
                  .then(response => {
                    console.log(response);
                    this.ready = true;

                    this.couponDescription = this.couponSuccessResponse(
                      response.data
                    );
                  })
                  .catch(e => {
                    console.log("error");
                    console.log(e);
                    this.ready = true;
                    this.coupon = false;
                    this.input.coupon = "";
                    this.couponDescription =
                      "Denne kode er udløbet eller kan ikke bruges.";
                  });
              } else {
                console.log("ready");
                this.ready = true;
                this.couponDescription = "";
              }


            }


      }).catch(e => {
        this.$router.push(
          {
            name: "creditcard",
            query: { redirect: "invitation", invitation: this.coupon }
          },
          () => {
            return;
          }
        );

                  });
      });
    }
  },
  methods: {
    getInfo() {
      this.$userService.getCoupon(this.input.coupon).then(response => {
        console.log(this.$refs);
        this.$refs.getinfo.reset();
        this.coupon = this.input.coupon;
        this.ready = true;
        this.couponDescription = this.couponSuccessResponse(response.data);
      });
    },
    startSubscription() {
      this.$userService
        .subscribe(this.coupon)
        .then(data => {
          console.log("subsc");
          console.log(data);
          this.$userService.getCustomer().then(subscription => {
            console.log(subscription);
            this.$router.push(
              {
                name: "product-settings",
                query: { redirect: "invitation", invitation: this.coupon }
              },
              () => {
                return;
              }
            );
          });
        })
        .catch(err => {
          console.log("error");
          console.log(err.response.data.code);
          this.errorMessage = "Der er sket en fejl. Prøv evt. med et andet kort.";
          if (err.response.data.code === "card_declined") {
            this.errorMessage = "Dit kort blev afvist.";
          }
          this.suggestCreditcard = true;
          this.$refs.request.reset();
        });
    }
  }
};
</script>